import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  CButton,
  CModal, CModalBody, CModalHeader,
} from '@coreui/react';
import { useDispatch, useSelector } from 'react-redux';
import useGlobalSelectionsContext from '../../../core/hooks/useGlobalSelectionsContext';
import { ServerSideTableSimple } from '../../../Shared/ServerSideTable';
import { tableFields } from './constants';
import { fetchPetitions } from './actions';
import PetitionsLabels from '../../ManagePetitions/PetitionsTable/PetitionLabels';

const PetitionsModal = ({
  show, onClose, onSubmit, preselectedPetition,
}) => {
  const [selectedPetitionId, changeSelectedPetitionId] = useState(preselectedPetition);
  const {
    initiativeId, organizationId, refetchCurrentPageData, initiativeSettings,
  } = useGlobalSelectionsContext();
  const {
    data,
    perPage,
    page,
    lastPage,
    loading,
    search,
    sort,
    order,
  } = useSelector((state) => state.manageProspects.petitions);

  const dispatch = useDispatch();

  const query = {
    search,
    sort,
    order,
    page,
    lastPage,
    perPage,
    filter_by_status: 'checked_out',
    filter_by_method: 'blank',
    initiative_id: initiativeId,
    organization_id: organizationId,
  };

  const onTableFetch = (queryVal) => {
    dispatch(fetchPetitions(queryVal));
  };

  const handleRowSelect = (event, id) => {
    if (event.target.checked) {
      changeSelectedPetitionId(id);
    }
  };

  const handleSubmit = () => onSubmit(
    data?.find(({ id }) => id === selectedPetitionId),
  );

  const normalizedData = data.map((item) => ({
    ...item,
    _selected: item.id === selectedPetitionId,
  }));

  useEffect(() => {
    onTableFetch(query);
    // eslint-disable-next-line
  }, [refetchCurrentPageData]);

  return (
    <CModal size="lg" show={show} onClose={onClose}>
      <CModalHeader closeButton>
        <h4 className="mb-0">
          Select Petition
        </h4>
      </CModalHeader>
      <CModalBody>
        <ServerSideTableSimple
          query={query}
          onFetch={onTableFetch}
          loading={loading}
          fields={tableFields.filter((el) => {
            if (initiativeSettings?.show_external_id) return true;
            return el.key !== 'external_id';
          })}
          data={normalizedData}
          tableFilter
          onRowCheck={handleRowSelect}
          selectType="radio"
          itemsPerPageSelect={{ label: 'Items per page:', values: [50, 10, 20, 100] }}
          scopedSlots={{
            external_id: (item) => <td className="user-select-none">{item.external_id || ''}</td>,
            labels: (item) => (
              <td>
                <PetitionsLabels labels={item.labels} hasDuplicates={item.has_duplicates} />
              </td>
            ),
          }}
        />

        {selectedPetitionId && (
          <CButton
            color="primary"
            className="m-2"
            size="lg"
            onClick={handleSubmit}
          >
            Next
          </CButton>
        )}
      </CModalBody>
    </CModal>
  );
};

PetitionsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  preselectedPetition: PropTypes.number,
};

PetitionsModal.defaultProps = {
  preselectedPetition: undefined,
};

export default PetitionsModal;
